export const Types = {
  audio: 'audio',
  avaliacao: 'avaliacao',
  flip: 'flip',
  imagem: 'imagem',
  link: 'link',
  texto: 'texto',
  video: 'video',
  embed: 'embed',
};

export const TypesContent = ['raw-html-embed', 'href'];

type TypeKey = keyof typeof Types;
type TypeValue = (typeof Types)[TypeKey];

export function mapTypeToIcon(type: string): string {
  const normalizedType = type.toLowerCase();
  const typeMapping: Record<TypeValue, string> = {
    [Types.audio]: 'icon-headphone.svg',
    [Types.avaliacao]: 'icon-book-pencil.svg',
    [Types.flip]: 'icon-books.svg',
    [Types.imagem]: 'icon-landscape.svg',
    [Types.link]: 'icon-attachment.svg',
    [Types.texto]: 'icon-text-lines.svg',
    [Types.video]: 'icon-film-alt.svg',
    [Types.embed]: 'icon-piece.svg',
  };

  return typeMapping[normalizedType as TypeValue] || 'icon-help.svg';
}

export function mapTypeToStyle(type: string, attribute: string): string {
  switch (type) {
    case Types.avaliacao:
      return `${attribute}-base-trilhas-tipo-quiz`;
    case Types.imagem:
      return `${attribute}-base-trilhas-tipo-image`;
    case Types.flip:
      return `${attribute}-base-trilhas-tipo-ebook`;
    case Types.texto:
      return `${attribute}-base-trilhas-tipo-text`;
    case Types.embed:
      return `${attribute}-base-trilhas-tipo-embed`;
    default:
      return `${attribute}-base-trilhas-tipo-${type}`;
  }
}

export function getStyleTextIcon(type: string): string {
  switch (type) {
    case Types.avaliacao:
      return 'text-base-trilhas-tipo-quiz';
    case Types.imagem:
      return 'text-base-trilhas-tipo-image';
    case Types.flip:
      return 'text-base-trilhas-tipo-ebook';
    case Types.texto:
      return 'text-base-trilhas-tipo-text';
    case Types.embed:
      return 'text-base-trilhas-tipo-embed';
    default:
      return `text-base-trilhas-tipo-${type}`;
  }
}

export function getIcon(type: string): string {
  switch (type) {
    case Types.avaliacao:
      return 'assets/icons/icon-gestor-avaliacoes.svg';
    case Types.imagem:
      return 'assets/icons/icon-image-types.svg';
    case Types.flip:
      return 'assets/icons/icon-doc-types.svg';
    case Types.texto:
      return 'assets/icons/icon-text-types.svg';
    case Types.embed:
      return 'assets/icons/icon-piece.svg';
    default:
      return `assets/icons/icon-${type}-types.svg`;
  }
}
